module.exports.verticalSiteConfigs = {
  news: {
    iconUrl: 'nbcnews',
    twitterContentCreator: 'NBCNews',
    siteLogoUrl: 'https://media2.s-nbcnews.com/j/newscms/2020_23/3377726/nbcnews-schema_56f69b5ce9bcbde8daef249a31212df2.social_share_1024x768_scale.png',
    ogSiteName: 'NBC News',
    siteParamFacebook: 'nbcnews',
    siteParamGoogle: 'nbcnews',
    siteParamInstagram: 'nbcnews',
    siteParamTwitter: 'nbcnews',
    siteParamYoutube: 'nbcnews',
    twitterSite: '@NBCNews',
    siteUrl: 'http://www.nbcnews.com',
    twitterIntentVia: 'NBCNews',
  },

  today: {
    iconUrl: 'today',
    twitterContentCreator: 'TodayShow',
    siteLogoUrl: 'https://media2.s-nbcnews.com/j/newscms/2020_23/3377721/today-schema_56f69b5ce9bcbde8daef249a31212df2.social_share_1024x768_scale.png',
    ogSiteName: 'TODAY.com',
    siteParamFacebook: 'todayshow',
    siteParamGoogle: 'todayshow',
    siteParamInstagram: 'todayshow',
    siteParamTwitter: 'today',
    siteParamYoutube: 'today',
    twitterSite: '@TodayShow',
    siteUrl: 'http://www.today.com',
    twitterIntentVia: 'NBCNews',
  },
  msnbc: {
    iconUrl: 'msnbc',
    twitterContentCreator: 'MSNBC',
    siteLogoUrl: 'https://media4.s-nbcnews.com/j/newscms/2020_23/3377716/msnbc-schema_56f69b5ce9bcbde8daef249a31212df2.social_share_1024x768_scale.png',
    ogSiteName: 'MSNBC.com',
    siteParamFacebook: 'msnbc',
    siteParamGoogle: 'msnbc',
    siteParamInstagram: 'msnbc',
    siteParamTwitter: 'msnbc',
    siteParamYoutube: 'msnbc',
    twitterSite: '@MSNBC',
    siteUrl: 'http://www.msnbc.com',
    twitterIntentVia: 'NBCNews',
  },
  noticias: {
    iconUrl: 'telemundo',
    twitterContentCreator: 'TELEMUNDO',
    siteLogoUrl: 'https://media1.s-nbcnews.com/j/newscms/2020_23/3377711/telemundo-schema_56f69b5ce9bcbde8daef249a31212df2.social_share_1024x768_scale.png',
    ogSiteName: 'TELEMUNDO.com',
    siteParamFacebook: 'noticiastelemundo',
    siteParamGoogle: 'telemundo',
    siteParamInstagram: 'NoticiasTelemundo',
    siteParamTwitter: 'TelemundoNews',
    siteParamYoutube: 'telemundo',
    twitterSite: '@TELEMUNDO',
    siteUrl: 'http://www.telemundo.com',
    twitterIntentVia: 'TelemundoNews',
  },
  entretenimiento: {
    iconUrl: 'telemundo',
    twitterContentCreator: 'TELEMUNDO',
    siteLogoUrl: 'https://media1.s-nbcnews.com/j/newscms/2020_23/3377711/telemundo-schema_56f69b5ce9bcbde8daef249a31212df2.social_share_1024x768_scale.png',
    ogSiteName: 'TELEMUNDO.com',
    siteParamFacebook: 'telemundo',
    siteParamGoogle: 'telemundo',
    siteParamInstagram: 'Telemundo',
    siteParamTwitter: 'Telemundo',
    siteParamYoutube: 'telemundo',
    twitterSite: '@TELEMUNDO',
    siteUrl: 'http://www.telemundo.com',
    twitterIntentVia: 'Telemundo',
  },
  shows: {
    iconUrl: 'telemundo',
    twitterContentCreator: 'TELEMUNDO',
    siteLogoUrl: 'https://media1.s-nbcnews.com/j/newscms/2020_23/3377711/telemundo-schema_56f69b5ce9bcbde8daef249a31212df2.social_share_1024x768_scale.png',
    ogSiteName: 'TELEMUNDO.com',
    siteParamFacebook: 'telemundo',
    siteParamGoogle: 'telemundo',
    siteParamInstagram: 'Telemundo',
    siteParamTwitter: 'Telemundo',
    siteParamYoutube: 'telemundo',
    twitterSite: '@TELEMUNDO',
    siteUrl: 'http://www.telemundo.com',
    twitterIntentVia: 'Telemundo',
  },
  telemundo: {
    iconUrl: 'telemundo',
    twitterContentCreator: 'TELEMUNDO',
    siteLogoUrl: 'https://media1.s-nbcnews.com/j/newscms/2020_23/3377711/telemundo-schema_56f69b5ce9bcbde8daef249a31212df2.social_share_1024x768_scale.png',
    ogSiteName: 'TELEMUNDO.com',
    siteParamFacebook: 'telemundo',
    siteParamGoogle: 'telemundo',
    siteParamInstagram: 'Telemundo',
    siteParamTwitter: 'Telemundo',
    siteParamYoutube: 'telemundo',
    twitterSite: '@TELEMUNDO',
    siteUrl: 'http://www.telemundo.com',
    twitterIntentVia: 'Telemundo',
  },
};
